import { APIError } from "@/adapters/api";

export const STAGES_LOCKED_REASON = "stages_locked";

export const STAGES_LOCKED_MESSAGE = "A estrutura desta obra está travada";

export function isStagesLockedError(err: unknown): boolean {
	return err instanceof APIError && err.reason === STAGES_LOCKED_REASON;
}
